export default __webpack_public_path__ + "static/media/1866.55ca0924.png";